module.exports = __webpack_public_path__ + "static/contact-9b7eac782d64298676cf68e791bc2c5d.png";